import SvgIcon from '@mui/material/SvgIcon';

export default function NebulaIcon() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2000 2000"
        shapeRendering="crispEdges"
        style={{ maxHeight: '20px' }}
      >
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M724.69 1868.2c282.25,0 539.17,52.95 732.57,139.67 -193.4,-149.52 -450.32,-240.87 -732.57,-240.87 -282.25,0 -539.17,91.35 -732.56,240.87 193.39,-86.72 450.31,-139.67 732.56,-139.67z"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M1992.13 594.99c-1.21,-6.02 -4.79,-18.22 -8.03,-23.4l-270.32 -210.58 -51.03 -334.59c-3.07,-5.18 -12.12,-14.54 -16.72,-18.55 -4.78,4.01 -13.66,13.21 -16.73,18.55l-51.02 334.59 -270.33 210.58c-3.07,5.18 -6.82,17.54 -8.02,23.4 5.8,2 18.6,5.01 24.75,5.01l321.35 -124.01 321.33 124.01c6.15,0 18.96,-3.01 24.77,-5.01z"
        />
        <polygon
          fill="currentColor"
          fillRule="nonzero"
          points="240,1578.76 483.15,1578.76 483.15,524.15 958.16,1578.76 1209.35,1578.76 1209.35,7.87 967.82,7.87 967.82,1060.28 496.03,7.87 240,7.87 "
        />
      </svg>
    </SvgIcon>
  );
}
